import React, { createContext, useContext } from 'react';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const experimentsList = {
  tabsArrow: false
};
const ExperimentalContext = createContext({});
const useExperimentalContext = () => useContext(ExperimentalContext);
const ExperimentalProvider = (props) => {
  const { children, experiments: experimentsProp } = props;
  const experiments = __spreadValues(__spreadValues({}, experimentsList), experimentsProp);
  return /* @__PURE__ */ React.createElement(ExperimentalContext.Provider, {
    value: experiments
  }, children);
};
ExperimentalProvider.displayName = "Maestro.ExperimentalProvider";
const useExperiment = (experiment) => {
  const experiments = useExperimentalContext();
  const isEnabled = experiment in experiments ? experiments[experiment] : false;
  return [isEnabled];
};

export { ExperimentalProvider, useExperiment, useExperimentalContext };
//# sourceMappingURL=ExperimentalProvider.es.js.map
